export const TIME_FRAMES = {
  '5': 5,
  '10': 10,
  '20': 20,
};
